import { IIconProps } from "../types"

export default function IconUR6(props: IIconProps) {
  const width = props.size || props.width || (105 / 5) * 3
  const height = props.size || props.height || (100 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 105 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.5292 1.03187C44.7969 0.272113 55.5034 0.182142 63.7708 1.20182C72.0281 2.21149 77.8463 4.33081 81.785 6.44014C85.7237 8.55946 87.7931 10.6788 90.2023 14.9074C92.6115 19.1361 95.3606 25.484 97.7599 31.792C100.159 38.09 102.188 44.348 103.148 51.6756C104.108 58.9933 103.978 67.3706 103.188 73.9285C102.408 80.4864 100.949 85.2249 98.8095 89.0337C96.6602 92.8424 93.8311 95.7115 90.9621 97.361C88.093 99.0105 85.1939 99.4403 81.0952 99.0604C77.0065 98.6806 71.7282 97.491 67.1697 96.4813C62.6211 95.4616 58.7924 94.6119 55.5834 94.232C52.3644 93.8521 49.7653 93.9421 47.2461 94.4019C44.7169 94.8718 42.2677 95.7115 39.6285 96.6412C36.9894 97.5809 34.1603 98.5906 31.6411 98.8405C29.1119 99.1004 26.8926 98.5906 23.8336 97.191C20.7746 95.8015 16.8658 93.5122 13.8868 90.7231C10.9077 87.934 8.83838 84.6351 6.95898 81.2462C5.08958 77.8572 3.41012 74.3884 2.30048 71.0094C1.19083 67.6205 0.651006 64.3216 0.501054 61.4925C0.341105 58.6534 0.571032 56.2842 0.920919 53.785C1.26081 51.2858 1.72066 48.6666 4.28984 41.3489C6.84902 34.0313 11.5175 22.0151 14.9164 15.1174C18.3253 8.21957 20.4647 6.44014 23.4537 4.84065C26.4327 3.23116 30.2615 1.79163 37.5292 1.03187Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
